module.exports = __webpack_public_path__ + "static/media/MOF_interior2.bd2bcb4d.jpg";